import fertigationDataConfig from '@/api/config/fertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { GlobalExclusionTimeRequest } from '@/types/fertigation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

function useGlobalExclusionTime() {
  const { t } = useTranslation()

  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation(
    (payload: GlobalExclusionTimeRequest) =>
      fertigationDataConfig.globalExclusionTime(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.fertigation])
        toast.success(t('programs.globalExclusion.applySuccess'))
        closeSidebar()
      },
      onError: (error: any) => {
        if (error?.statusCode === 400) {
          toast.error(error?.message)
        } else toast.error(t('programs.globalExclusion.applyError'))
      },
    },
  )
}

export default useGlobalExclusionTime
